export default {
  addressTypes: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/addressTypes/state.js